import {enqueueSnackbar} from "notistack";
import axios from "axios";

export const apiClient = async (
  url: string,
  method: string,
  data: object | FormData = {},
  token?: string
): Promise<any> => {
  const bearer =
    token || (typeof window !== "undefined" ? localStorage.getItem("token") : "");
  const baseURL = process.env.REACT_APP_API_BASE_URL ||  "https://messenger.factfactor.ru"
  const isFormData = data instanceof FormData;

  return axios
    .request({
      url,
      method,
      data,
      baseURL: "https://messenger.factfactor.ru",
      headers: {
        Accept: "application/json",
        // Accept: isFormData ? "multipart/form-data" : "application/json",
        ...(isFormData ? {} : {"Content-Type": "application/json"}),
        Authorization: bearer ? `Bearer ${bearer}` : "",
      },
    })
    .then(({status, data}) => {
      if ([200, 201, 204].includes(status)) return data;

      enqueueSnackbar(data?.message || "Что-то пошло не так", {variant: "error"});
    })
    .catch(err => {
      if (err?.status === 401) {
        enqueueSnackbar(err?.response?.data?.message || "Не авторизован", {variant: "error"});
        return err;
      }

      if(err.response?.data?.error === "timeout of 5000ms exceeded" || err.response?.data?.error === "aborted") {
        return;
      }

      enqueueSnackbar(err.response?.data?.error || err.response?.statusText || "Что-то пошло не так", {
        variant: "error",
      });

      throw err; 
    });
};
